module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/12398f42368ff5cc10c45a38bac8233a.png";